// @ts-nocheck
import {
    chain,
    RemoveStockedItemsFilter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { addToChainAfter, HandlerWithResult } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, RemoveStockedItemsFilter, props => {
    if (props.parameter.inStockRealTime !== undefined) {
        props.result.inStockRealTime = props.parameter.inStockRealTime;
    }
});
